import ApiEndpoint from "./ApiEndpoint";
import { AxiosResponse } from "axios";
import UploadedFile from "../../../model/UploadedFile";

export class Endpoint extends ApiEndpoint {
    public post = (file: File): Promise<AxiosResponse<UploadedFile>> => {
        let body = new FormData();
        body.append('mimeType', file.type);
        body.append('fileName', file.name);
        body.append('size', String(file.size));
        body.append('file', file);
        return this.connection.post(
            '/files',
            body,
            {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }
        );
    }
}
